import { Pipe, PipeTransform } from '@angular/core';

import { WhiService } from '../../shared/services/whi.service';

@Pipe({
    name: 'showWhiButton',
    standalone: false
})
export class ShowWhiButtonPipe implements PipeTransform {

  constructor(private readonly whiService: WhiService) {}

  transform(_: boolean): boolean {
    return !!this.whiService.getHookUrl();
  }
}
